import clsx from 'clsx';
import dayjs from 'dayjs';

import TagWithHover from 'components/TagWithHover';

import classes from './Tags.module.scss';

const Tags = ({ userInfo, classname, reviewDate }) => {
  const isIncentivized =
    userInfo.incentivized && userInfo.incentivized !== 'NoIncentive';
  const isOrganic = userInfo.incentivized === 'NoIncentive';

  const isHighlyRelevant = dayjs().diff(dayjs(reviewDate), 'month') <= 12;

  const isPowerUser =
    (userInfo.time_used !== 'Less than 6 months' &&
      userInfo.frequency_of_use === 'daily') ||
    ((userInfo.time_used === '1-2 years' ||
      userInfo.time_used === '2+ years') &&
      userInfo.frequency_of_use === 'weekly');
  return (
    <div className={clsx(classes.root, classname)}>
      {isPowerUser && <TagWithHover variant="Frequent user" />}
      {isHighlyRelevant && <TagWithHover variant="Highly relevant" />}
      {isOrganic && <TagWithHover variant="Organic review" />}
      {userInfo.is_validated && <TagWithHover variant="Verified review" />}
      {isIncentivized && <TagWithHover variant="Incentivized review" />}
    </div>
  );
};

export default Tags;
